document.addEventListener("DOMContentLoaded", () => {
    const wrapper = document.querySelector('.hp-timeline-v1');
    const accordions = document.querySelectorAll(".hp-timeline__progress-item");
    const noAnimation = wrapper && wrapper.dataset.noAnimation === 'true';

    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".hp-timeline__item-text");
        accordion.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
    };

    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".hp-timeline__item-text");
        accordion.classList.remove("active");
        content.style.maxHeight = null;
    };

    if (noAnimation) {
        openAccordion(accordions[0]);

        accordions.forEach((accordion, idx) => {
            accordion.addEventListener('click', () => {
                accordions.forEach((item, i) => {
                    if (i === idx) {
                        openAccordion(item);
                    } else {
                        closeAccordion(item);
                    }
                });
            });
        });

        return;
    }

    let current = 0;
    const intervalTime = 5000;
    let interval;

    function setActive(index) {
        accordions.forEach((item, i) => {
            const timeline = item.querySelector(".hp-timeline__progressbar-way");

            if (i === index) {
                openAccordion(item);
            } else {
                closeAccordion(item);
            }

            timeline.style.transition = 'none';
            timeline.style.width = '0%';
        });

        const activeTimeline = accordions[index].querySelector('.hp-timeline__progressbar-way');
        requestAnimationFrame(() => {
            activeTimeline.style.transition = `width ${intervalTime}ms linear`;
            activeTimeline.style.width = '100%';
        });
    }

    function nextItem() {
        current = (current + 1) % accordions.length;
        setActive(current);
    }

    function startAutoSwitch() {
        clearInterval(interval);
        interval = setInterval(nextItem, intervalTime);
    }

    accordions.forEach((accordion, idx) => {
        accordion.addEventListener('click', () => {
            current = idx;
            setActive(current);
            startAutoSwitch();
        });
    });

    setActive(current);
    startAutoSwitch();
});
